export const GA_MEASUREMENT_ID = 'UA-121554636-2';
